module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"set_products_weight":"set products weight","manage_your_parcel":"Manage your parcel","here":"here","we_will_notify_you":"We will notify you on every new order created"},"id":{}}')
  delete Component.options._Ctor
}
